import { Box } from '@startuptools/ui/Box';
import { WelcomeDialog } from './components/WelcomeDialog';
import { Navbar } from './components/Navbar';
import { Header } from './components/Header';
import { Main } from './components/main/Main';
import { DownloadedProvider } from './contexts/DownloadedContext';
import { SubscriptionStatusProvider } from './contexts/SubscriptionStatusContext';
import { isNil } from 'lodash-es';
import { EmailProvider } from './contexts/EmailContext';
import { useCompanyQuery, useCurrentUserQuery } from '../graphql/react-operations';
import { useCompanyIdMaybe } from '@startuptools/common/react-wrapper';
import { useUserIdMaybe } from '../components/react-wrapper/UserIdContext';

export const FreeTemplates = ({ isInPlatform }: { isInPlatform: boolean }) => {
  const userId = useUserIdMaybe();
  const { data: userData } = useCurrentUserQuery({ skip: !userId });
  const companyId = useCompanyIdMaybe();
  const { data: companyData } = useCompanyQuery({ variables: { id: companyId ?? '' }, skip: !companyId });

  const urlParams = new URLSearchParams(window.location.search);
  const emailParam = urlParams.get('email');
  const email = userData?.currentUser?.email ?? emailParam;

  return (
    <SubscriptionStatusProvider companyId={isNil(companyData?.company) ? undefined : companyData?.company.id}>
      <DownloadedProvider>
        <EmailProvider email={email}>
          {!isInPlatform && <Navbar />}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              bgcolor: '#FFFFFF',
              width: '100dvw',
              maxWidth: '1920px',
              paddingLeft: '2.4 rem',
              minHeight: '100dvh',
              maxHeight: '100dvh',
              overflow: !isInPlatform ? 'auto' : undefined,
            }}
          >
            <Box sx={{ zIndex: 10 }}>
              <Header user={userData?.currentUser} />
            </Box>
            <Box bgcolor="#FAFCFF" sx={{ zIndex: 20 }}>
              <Main />
            </Box>

            {!isInPlatform && <WelcomeDialog />}
          </Box>
        </EmailProvider>
      </DownloadedProvider>
    </SubscriptionStatusProvider>
  );
};
